export default {
  ActivityAndGeneralStats: "_ACTIVITY_GENERAL_STATS_",
  EmployeeEngagement: "_EMPLOYEE_ENGAGEMENT_",
  IntelAndInsights: "_INTEL_INSIGHTS_",
  PeopleBalanceSheet: "_PEOPLE_BALANCE_SHEET_",
  PerformanceAndProgression: "_PERFORMANCE_PROGRESSION_",
  PerformanceComparisonChart: "_COMPARISON_LINE_CHART_",
  CustomReport: "_CUSTOM_REPORT_",
  ReportSelection: "_REPORT_SELECTION_",
}



// WEBPACK FOOTER //
// ./src/state/actions/actionTypePrefixes.js